import React, { useState } from 'react';
import { ExploreDrawerOption } from 'features/explore/components/explore-side-bar/components/explore-drawer/explore-drawer-option/explore-drawer-option';
import { Button, Dropdown, MultilineDropdownMenu, UnifiedSelectBox } from '@placer-ui/components';
import { openChainsReport } from 'utils/navigation/navigation';
import { useSendExploreSplunkEvent } from 'features/explore/hooks/use-explore-tracking';
import { AreaType, BasePlaceEntity } from '@placer-ui/types';
import styles from './report-options.module.scss';

// TODO: Replace with Record<AreaType, string> when all options are available
const CHAIN_DICT: Record<string, string> = {
    nationwide: 'Nationwide',
};

type ChainReportOptionProps = {
    poi: BasePlaceEntity;
};

export const ChainReportOption = ({ poi }: ChainReportOptionProps) => {
    const [value, setValue] = useState<AreaType>('nationwide');
    const sendSplunkEvent = useSendExploreSplunkEvent();

    const poiName = poi.name;
    const selectedTitle = `${poi.name} ${CHAIN_DICT[value]}`;

    const items = [
        {
            label: poiName,
            value: 'nationwide',
            description: 'Nationwide',
        },
    ];

    const onOpenChainReport = () => {
        sendSplunkEvent({
            component: 'Report Options Panel',
            action: 'open report',
            value: 'chain',
        });

        openChainsReport(poi.parent_chain_id);
    };

    return (
        <ExploreDrawerOption
            poi={poi}
            title="Open Chain Report"
            subtitle={`For ${selectedTitle}`}
            testId={'chain-option'}
            value={'chain'}
        >
            <div className={styles.chainDropdownWrapper}>
                <Dropdown
                    scaleToAnchor
                    trigger={<UnifiedSelectBox size="small" value={selectedTitle} />}
                    closeOnSelection
                    appendToParent
                >
                    <MultilineDropdownMenu
                        onItemSelection={({ value }) => setValue(value as AreaType)}
                        items={items}
                    />
                </Dropdown>
            </div>
            <div className={styles.chainOpenReportButton}>
                <Button
                    size="small"
                    testId="report-options-open-chain-report"
                    onClick={onOpenChainReport}
                    fullWidth
                >
                    Open Report
                </Button>
            </div>
        </ExploreDrawerOption>
    );
};
